﻿const defaults = {
    tokenUri: '/authenticate/getToken',
    userInfoUri: '/customer/info',
    logoutUri: '/customer/logout',
    logoutRedirectTo: 'default',
    unauthorizedRedirectTo: 'login',
    forbiddenRedirectTo: 'forbidden',
    rememberMeDuration: 14, //in days (nopCommerce)
    tokenStorageType: 'localStorage'
};

export default defaults;